import { ReactNode } from "react";
import { Box, BoxProps } from "@xcorejs/ui";
import styled from "styled-components";

type ProductTagProps = {
  variant: "gray" | "new" | "ipCertified";
  centered?: boolean;
  children?: ReactNode;
} & BoxProps;

const ProductTagStyle = styled(Box)<{ variant: ProductTagProps["variant"] }>`
  color: white;
  font-family: "Avenir", sans-serif;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 700;
  padding: ${({ variant }) => (variant === "ipCertified" ? "0.8rem 1.5rem" : "1.2rem 1.7rem")};
  align-items: center;

  * {
    font-family: "Avenir", sans-serif;
  }
`;

const ProductTag = ({ variant, children, centered, ...props }: ProductTagProps) => {
  const isNew = variant === "new";
  const isIpCertified = variant === "ipCertified";
  const color = isNew ? "primary" : isIpCertified ? "ipCertified" : variant === "gray" ? "rgb(94, 96, 98)" : null;

  return (
    <ProductTagStyle backgroundColor={color} borderColor={color} display={centered ? "inline" : "flex"} {...{ ...props, variant }}>
      {variant === "ipCertified" && (
        <Box ml="-.5rem" mr=".5rem">
          <svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.69 165.87">
            <path
              fill="#ffffff"
              // eslint-disable-next-line react/jsx-props-no-multi-spaces
              d="M49.43,2.09c.74,5.49,.66,11.02,.28,16.5-.61,8.88-2.16,17.65-4.58,26.24-2.22,7.88-4.59,15.71-6.8,23.6-2.85,10.15-5.06,20.42-4.7,31.06,.32,9.61,2.76,18.53,8.57,26.35,5.25,7.07,12.08,11.98,20.68,13.86,13.19,2.88,24.67-2.22,31.91-13.83,1.34-2.15,2.43-4.43,3.57-6.78,.39,1.56,.43,3.12,.13,4.65-1.61,8.14-4.48,15.73-9.58,22.39-5.9,7.71-13.37,13.29-22.5,16.65-5.62,2.06-11.42,3.13-17.4,3.09-3.4-.02-6.74-.65-10.04-1.4-13.36-3.07-23.82-10.36-31.26-21.88-4.21-6.52-6.61-13.71-7.46-21.41-.82-7.42,.47-14.64,2.43-21.75,2.25-8.16,6.01-15.66,10.28-22.92,5.31-9.01,11.3-17.59,16.87-26.43,5.93-9.4,11.16-19.16,14.63-29.76,1.82-5.57,3.19-11.27,3.7-17.15,.09-1.05,.28-2.1,.43-3.15,1.33,.28,.11,1.57,.83,2.09"
            />
          </svg>
        </Box>
      )}
      {children}
    </ProductTagStyle>
  );
};

export default ProductTag;
